(function () {
  var configCache = null;
  var configPromise = null;

  function getConfigUrl() {
    if (window.themeVariables && window.themeVariables.pdpReviewsConfigUrl) {
      return window.themeVariables.pdpReviewsConfigUrl;
    }

    return '/cdn/shop/t/1/assets/pdp-reviews-config.json';
  }

  function loadConfig() {
    if (configCache) {
      return Promise.resolve(configCache);
    }

    if (!configPromise) {
      configPromise = fetch(getConfigUrl())
        .then(function (response) {
          if (!response.ok) {
            throw new Error('Failed to load reviews config');
          }

          return response.json();
        })
        .then(function (data) {
          configCache = data;
          return data;
        })
        .catch(function () {
          configPromise = null;
          return {};
        });
    }

    return configPromise;
  }

  function normalizeKey(key) {
    return String(key || '')
      .toLowerCase()
      .replace(/™/g, '')
      .trim();
  }

  function resolveRecord(config, key) {
    if (!config || typeof config !== 'object') {
      return null;
    }

    if (key && config[key]) {
      return config[key];
    }

    var normalizedKey = normalizeKey(key);

    for (var recordKey in config) {
      if (!Object.prototype.hasOwnProperty.call(config, recordKey) || recordKey === '_default') {
        continue;
      }

      if (normalizeKey(recordKey) === normalizedKey) {
        return config[recordKey];
      }
    }

    return config._default || null;
  }

  function renderStars(rating, size, color, emptyColor) {
    var numericRating = Number(rating) || 0;
    var fullStars = Math.floor(numericRating);
    var hasHalf = numericRating % 1 >= 0.5;
    var html =
      '<span class="kop-stars" role="img" aria-label="' +
      numericRating +
      ' out of 5 stars" style="--kop-star-size:' +
      size +
      'px;--kop-star-gap:2px;--kop-star-color:' +
      color +
      ';--kop-star-empty:' +
      emptyColor +
      '">';

    for (var i = 1; i <= 5; i += 1) {
      if (i <= fullStars) {
        html += '<span class="kop-stars__star kop-stars__star--full"></span>';
      } else if (hasHalf && i === fullStars + 1) {
        html += '<span class="kop-stars__star kop-stars__star--half"></span>';
      } else {
        html += '<span class="kop-stars__star kop-stars__star--empty"></span>';
      }
    }

    html += '</span>';
    return html;
  }

  function hydrateSnippet(snippet, record) {
    if (!snippet || !record) {
      return;
    }

    var purchaser = record.purchaser_name || 'Kim';
    var reviewCount = record.review_count || '';
    var reviewRating = record.review_rating || 4.8;
    var avatars = Array.isArray(record.avatars) ? record.avatars : [];

    var purchaserEl = snippet.querySelector('.pdp-reviews-snippet__purchase-text strong');
    if (purchaserEl) {
      purchaserEl.textContent = purchaser;
    }

    snippet.querySelectorAll('.pdp-reviews-snippet__avatars img').forEach(function (img, index) {
      if (avatars[index]) {
        img.src = avatars[index];
      }
    });

    snippet.querySelectorAll('.pdp-reviews-snippet__rating-text').forEach(function (el) {
      el.textContent = reviewRating + ' / 5 (' + reviewCount + ' reviews)';
    });

    snippet.querySelectorAll('.tp-review-count').forEach(function (el) {
      el.textContent = '(' + reviewCount + ' reviews)';
    });

    snippet.querySelectorAll('.pdp-reviews-snippet__stars').forEach(function (el) {
      el.innerHTML = renderStars(reviewRating, 16, '#ff5801', '#E0E0E0');
    });

    snippet.querySelectorAll('.pdp-reviews-snippet__variant--control .kop-stars').forEach(function (el) {
      el.outerHTML = renderStars(reviewRating, 14, '#FFB800', '#E0E0E0');
    });
  }

  function hydrateAll(config) {
    document.querySelectorAll('.pdp-reviews-snippet[data-reviews-key]').forEach(function (snippet) {
      var key = snippet.getAttribute('data-reviews-key');
      var record = resolveRecord(config, key);
      hydrateSnippet(snippet, record);
    });
  }

  function init() {
    loadConfig().then(function (config) {
      hydrateAll(config);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
